<div class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
  <div class="max-w-6xl mx-auto">
    <!-- Header -->
    <div class="mb-8 flex items-center justify-between">
      <div>
        <button (click)="goBack()" class="flex items-center text-slate-600 hover:text-slate-900 mb-4 transition-colors">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
          </svg>
          Back to Dashboard
        </button>
        <h1 class="text-4xl font-bold text-slate-900 mb-2">
          System Settings
        </h1>
        <p class="text-slate-600">Configure your chatbot system preferences</p>
      </div>
      <div class="flex gap-3">
        <button (click)="resetSettings()" class="px-6 py-3 bg-white text-slate-700 rounded-xl font-semibold hover:bg-slate-100 transition-all duration-300 shadow-md hover:shadow-lg border border-slate-200">
          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
          </svg>
          Reset to Defaults
        </button>
        <button (click)="saveSettings()" class="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105">
          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          Save Changes
        </button>
      </div>
    </div>

    <!-- Success/Error Messages -->
    <div *ngIf="saveSuccess" class="mb-6 p-4 bg-emerald-50 border border-emerald-200 rounded-xl text-emerald-800 flex items-center animate-fade-in">
      <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      Settings saved successfully!
    </div>

    <div *ngIf="saveError" class="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-800 flex items-center animate-fade-in">
      <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      Failed to save settings. Please try again.
    </div>

    <!-- Tabs -->
    <div class="bg-white rounded-2xl shadow-lg mb-6 p-2">
      <div class="flex gap-2 overflow-x-auto">
        <button (click)="setActiveTab('general')" 
                [class.bg-gradient-to-r]="activeTab === 'general'"
                [class.from-blue-600]="activeTab === 'general'"
                [class.to-indigo-600]="activeTab === 'general'"
                [class.text-white]="activeTab === 'general'"
                [class.text-slate-600]="activeTab !== 'general'"
                class="px-6 py-3 rounded-xl font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap">
          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
          </svg>
          General
        </button>
        <button (click)="setActiveTab('ai')" 
                [class.bg-gradient-to-r]="activeTab === 'ai'"
                [class.from-blue-600]="activeTab === 'ai'"
                [class.to-indigo-600]="activeTab === 'ai'"
                [class.text-white]="activeTab === 'ai'"
                [class.text-slate-600]="activeTab !== 'ai'"
                class="px-6 py-3 rounded-xl font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap">
          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
          </svg>
          AI Configuration
        </button>
        <button (click)="setActiveTab('performance')" 
                [class.bg-gradient-to-r]="activeTab === 'performance'"
                [class.from-blue-600]="activeTab === 'performance'"
                [class.to-indigo-600]="activeTab === 'performance'"
                [class.text-white]="activeTab === 'performance'"
                [class.text-slate-600]="activeTab !== 'performance'"
                class="px-6 py-3 rounded-xl font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap">
          <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
          Performance
        </button>
      </div>
    </div>

    <!-- Settings Content -->
    <div class="bg-white rounded-2xl shadow-lg p-8">
      <!-- General Settings Tab -->
      <div *ngIf="activeTab === 'general'" class="space-y-6 animate-fade-in">
        <div>
          <label class="block text-sm font-semibold text-slate-700 mb-2">Site Name</label>
          <input type="text" [(ngModel)]="settings.siteName" 
                 class="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all">
        </div>

        <div>
          <label class="block text-sm font-semibold text-slate-700 mb-2">Support Email</label>
          <input type="email" [(ngModel)]="settings.supportEmail" 
                 class="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all">
        </div>

        <div class="grid grid-cols-2 gap-6">
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">Max Concurrent Chats</label>
            <input type="number" [(ngModel)]="settings.maxConcurrentChats" 
                   class="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all">
          </div>

          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">Session Timeout (minutes)</label>
            <input type="number" [(ngModel)]="settings.sessionTimeout" 
                   class="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all">
          </div>
        </div>

        <div class="space-y-4 border-t border-slate-200 pt-6">
          <label class="flex items-center justify-between p-4 bg-slate-50 rounded-xl cursor-pointer hover:bg-slate-100 transition-colors">
            <div>
              <div class="font-semibold text-slate-800">Enable Notifications</div>
              <div class="text-sm text-slate-600">Send email notifications for new messages</div>
            </div>
            <input type="checkbox" [(ngModel)]="settings.enableNotifications" 
                   class="w-6 h-6 text-blue-600 rounded focus:ring-2 focus:ring-blue-500">
          </label>

          <label class="flex items-center justify-between p-4 bg-slate-50 rounded-xl cursor-pointer hover:bg-slate-100 transition-colors">
            <div>
              <div class="font-semibold text-slate-800">Enable Analytics</div>
              <div class="text-sm text-slate-600">Track user interactions and performance metrics</div>
            </div>
            <input type="checkbox" [(ngModel)]="settings.enableAnalytics" 
                   class="w-6 h-6 text-blue-600 rounded focus:ring-2 focus:ring-blue-500">
          </label>

          <label class="flex items-center justify-between p-4 bg-amber-50 rounded-xl cursor-pointer hover:bg-amber-100 transition-colors border border-amber-200">
            <div>
              <div class="font-semibold text-amber-900">Maintenance Mode</div>
              <div class="text-sm text-amber-700">Disable chatbot for system maintenance</div>
            </div>
            <input type="checkbox" [(ngModel)]="settings.maintenanceMode" 
                   class="w-6 h-6 text-amber-600 rounded focus:ring-2 focus:ring-amber-500">
          </label>
        </div>
      </div>

      <!-- AI Configuration Tab -->
      <div *ngIf="activeTab === 'ai'" class="space-y-6 animate-fade-in">
        <div class="bg-gradient-to-r from-emerald-50 to-blue-50 border border-emerald-200 rounded-xl p-4 mb-6">
          <div class="flex items-start">
            <svg class="w-6 h-6 text-emerald-600 mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <div class="text-sm text-slate-800">
              <strong class="text-emerald-700">Gemini 2.5 Flash Active:</strong> You're using the latest and most powerful free AI model from Google! This model offers superior performance, faster responses, and better understanding compared to previous versions.
            </div>
          </div>
        </div>

        <div class="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
          <div class="flex items-start">
            <svg class="w-5 h-5 text-blue-600 mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <div class="text-sm text-blue-800">
              <strong>Important:</strong> Changes to AI configuration may affect response quality. Test thoroughly before deploying to production.
            </div>
          </div>
        </div>

        <div>
          <label class="block text-sm font-semibold text-slate-700 mb-2">Gemini API Key</label>
          <input type="password" [(ngModel)]="settings.geminiApiKey" 
                 class="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all font-mono">
          <p class="text-xs text-slate-500 mt-2">Your API key is encrypted and stored securely</p>
        </div>

        <div>
          <label class="block text-sm font-semibold text-slate-700 mb-2">AI Model</label>
          <select [(ngModel)]="settings.geminiModel" 
                  class="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all">
            <option value="gemini-2.5-flash">Gemini 2.5 Flash (Best Free Model - Recommended) ⭐</option>
            <option value="gemini-1.5-flash">Gemini 1.5 Flash (Fastest)</option>
            <option value="gemini-1.5-pro">Gemini 1.5 Pro (Most Capable)</option>
            <option value="gemini-pro">Gemini Pro (Balanced)</option>
          </select>
          <p class="text-xs text-emerald-600 mt-2 flex items-center">
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Gemini 2.5 Flash offers the best performance with free API tier
          </p>
        </div>

        <div class="grid grid-cols-2 gap-6">
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">Max Tokens</label>
            <input type="number" [(ngModel)]="settings.maxTokens" 
                   class="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all">
            <p class="text-xs text-slate-500 mt-2">Maximum response length (500-2000)</p>
          </div>

          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-2">Temperature</label>
            <div class="flex items-center gap-4">
              <input type="range" min="0" max="1" step="0.1" [(ngModel)]="settings.temperature" 
                     class="flex-1 h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-blue-600">
              <span class="text-sm font-mono bg-slate-100 px-3 py-1 rounded-lg min-w-[4rem] text-center">{{settings.temperature}}</span>
            </div>
            <p class="text-xs text-slate-500 mt-2">Lower = more focused, Higher = more creative</p>
          </div>
        </div>
      </div>

      <!-- Performance Tab -->
      <div *ngIf="activeTab === 'performance'" class="space-y-6 animate-fade-in">
        <div class="grid grid-cols-3 gap-6 mb-8">
          <div class="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-xl p-6 border border-emerald-200">
            <div class="text-emerald-600 text-sm font-semibold mb-2">API Response Time</div>
            <div class="text-3xl font-bold text-emerald-900">245ms</div>
            <div class="text-xs text-emerald-600 mt-1">Average last 24h</div>
          </div>

          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
            <div class="text-blue-600 text-sm font-semibold mb-2">Uptime</div>
            <div class="text-3xl font-bold text-blue-900">99.8%</div>
            <div class="text-xs text-blue-600 mt-1">Last 30 days</div>
          </div>

          <div class="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 border border-purple-200">
            <div class="text-purple-600 text-sm font-semibold mb-2">Cache Hit Rate</div>
            <div class="text-3xl font-bold text-purple-900">87%</div>
            <div class="text-xs text-purple-600 mt-1">FAQ cache efficiency</div>
          </div>
        </div>

        <div class="bg-slate-50 rounded-xl p-6 border border-slate-200">
          <h3 class="text-lg font-bold text-slate-800 mb-4">Performance Recommendations</h3>
          <ul class="space-y-3">
            <li class="flex items-start">
              <svg class="w-5 h-5 text-emerald-500 mr-3 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <div>
                <div class="font-semibold text-slate-800">Database queries optimized</div>
                <div class="text-sm text-slate-600">All FAQ lookups using indexed search</div>
              </div>
            </li>
            <li class="flex items-start">
              <svg class="w-5 h-5 text-emerald-500 mr-3 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <div>
                <div class="font-semibold text-slate-800">Caching enabled</div>
                <div class="text-sm text-slate-600">Frequently accessed FAQs cached for 1 hour</div>
              </div>
            </li>
            <li class="flex items-start">
              <svg class="w-5 h-5 text-amber-500 mr-3 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
              <div>
                <div class="font-semibold text-slate-800">Consider load balancing</div>
                <div class="text-sm text-slate-600">Traffic increasing - plan for horizontal scaling</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
